/**
 * Handoff QSR en mostrador: Para llevar vs Comer acá.
 * Módulo en shared/ para evitar cycles entre pos y shell.
 */

export type PosFulfillmentType = 'pickup' | 'dine_in';

let posFulfillmentType: PosFulfillmentType = 'pickup';

export function getPosFulfillmentType(): PosFulfillmentType {
  return posFulfillmentType;
}

export function setPosFulfillmentType(value: PosFulfillmentType): void {
  posFulfillmentType = value === 'dine_in' ? 'dine_in' : 'pickup';
}

export function posFulfillmentHeaderTitle(type: PosFulfillmentType = posFulfillmentType): string {
  return type === 'dine_in' ? 'Comer acá' : 'Para llevar';
}
